import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-doc-delete",
  "use": "icon-doc-delete-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-doc-delete\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.70711 7.3934L7 8.1005L11.5 12.6005L7 17.1005L7.70711 17.8076L12.2071 13.3076L16.8995 18L17.6066 17.2929L12.9142 12.6005L17.6066 7.90811L16.8995 7.201L12.2071 11.8934L7.70711 7.3934Z\" fill=\"#999999\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol